module.exports = __webpack_public_path__ + "static/markham-fertility-centre-logo-d37e09236ddcf3de4591297bb838845d.png";